import { Controller } from "@hotwired/stimulus"

const DEMO_STORAGE_KEY = "demo_contact_groups"
const BUILTIN_SLUGS = new Set(["family", "friends", "coworkers", "clients"])

export default class extends Controller {
    static values = {
        filter: { type: String, default: "all" },
        groupSlug: { type: String, default: "" }
    }

    connect() {
        this._applyVisibility()
        this._onChanged = (e) => this._applyVisibility(e.detail?.contactId)
        document.addEventListener("demo-contact-groups:changed", this._onChanged)
    }

    disconnect() {
        document.removeEventListener("demo-contact-groups:changed", this._onChanged)
    }

    _applyVisibility(contactId = null) {
        let state = this._loadDemoState()
        let rows = contactId
            ? this.element.querySelectorAll(`[data-contact-id="${contactId}"]`)
            : this.element.querySelectorAll("[data-contact-id]")

        rows.forEach((row) => {
            let id = row.dataset.contactId
            let slugs = new Set(this._slugsForContact(id, state))
            row.hidden = !this._matchesFilter(slugs, state)
        })
    }

    _slugsForContact(contactId, state) {
        let base = rowBaseSlugs(contactId)
        let stored = state.memberships[contactId]
        if (!stored) return base
        return [...new Set([...base, ...stored])]
    }

    _matchesFilter(slugs, state) {
        let filter = this.filterValue || "all"
        if (filter === "all") return true
        if (BUILTIN_SLUGS.has(filter)) return slugs.has(filter)
        if (filter === "custom") {
            let customSlugs = new Set([
                "investors",
                ...state.custom_groups.map((group) => group.slug)
            ])
            if (this.groupSlugValue) return slugs.has(this.groupSlugValue)
            return [...slugs].some((slug) => customSlugs.has(slug))
        }
        return true
    }

    _loadDemoState() {
        try {
            let raw = sessionStorage.getItem(DEMO_STORAGE_KEY)
            let parsed = raw ? JSON.parse(raw) : {}
            return {
                memberships: parsed.memberships || {},
                custom_groups: parsed.custom_groups || []
            }
        } catch {
            return { memberships: {}, custom_groups: [] }
        }
    }
}

function rowBaseSlugs(contactId) {
    let template = document.getElementById(`demo_contact_${contactId}`)
    if (!template?.content) return []
    let section = template.content.querySelector("[data-contact-groups-member-slugs-value]")
    if (!section) return []
    try {
        return JSON.parse(section.dataset.contactGroupsMemberSlugsValue || "[]")
    } catch {
        return []
    }
}
